import React, { useState, useEffect } from 'react';
import { Liferay } from '../common/services/liferay/liferay.js';

const DebugInfo = () => {
  const [debugInfo, setDebugInfo] = useState({});
  const [showDebug, setShowDebug] = useState(false);

  const getPortalURL = () => {
    if (typeof window !== 'undefined' && window.Liferay && window.Liferay.ThemeDisplay) {
      return window.Liferay.ThemeDisplay.getPortalURL();
    }
    return window.location.origin;
  };

  const getCsrfToken = () => {
    if (typeof window !== 'undefined') {
      const csrfToken = document.querySelector('meta[name="_csrf"]');
      if (csrfToken) {
        return csrfToken.getAttribute('content');
      }
      if (Liferay.authToken) {
        return Liferay.authToken;
      }
    }
    return null;
  };

  const getUser = () => {
    if (typeof window !== 'undefined' && window.Liferay && window.Liferay.ThemeDisplay) {
      return {
        scopeGroupId: Liferay.ThemeDisplay.getScopeGroupId(),
        signedIn: Liferay.ThemeDisplay.isSignedIn()
      };
    }
    return {
      scopeGroupId: Liferay.ThemeDisplay.getScopeGroupId() || 'Not Available',
      signedIn: false
    };
  };

  useEffect(() => {
    if (showDebug) {
      const info = {
        liferayAvailable: typeof window !== 'undefined' && !!window.Liferay,
        portalURL: getPortalURL(),
        user: getUser(),
        authToken: Liferay.authToken ? 'Available' : 'Not Available',
        csrfToken: getCsrfToken() ? 'Available' : 'Not Available',
        currentLocation: window.location.href,
        timestamp: new Date().toISOString()
      };
      setDebugInfo(info);
    }
  }, [showDebug]);

  if (process.env.NODE_ENV === 'production' && !window.location.search.includes('debug=true')) {
    return null;
  }

  return (
    <div style={{ 
      position: 'fixed', 
      bottom: '10px', 
      right: '10px', 
      zIndex: 9999,
      fontFamily: 'monospace'
    }}>
      <button
        onClick={() => setShowDebug(!showDebug)}
        style={{
          background: '#007bff',
          color: 'white',
          border: 'none',
          padding: '5px 10px',
          borderRadius: '3px',
          cursor: 'pointer',
          fontSize: '12px'
        }}
      >
        {showDebug ? 'Hide Debug' : 'Show Debug'}
      </button>
      
      {showDebug && (
        <div style={{
          background: 'rgba(0,0,0,0.9)',
          color: '#00ff00',
          padding: '10px',
          borderRadius: '5px',
          marginTop: '5px',
          fontSize: '11px',
          maxWidth: '300px',
          maxHeight: '400px',
          overflow: 'auto'
        }}>
          <h4 style={{ margin: '0 0 10px 0', color: '#ffff00' }}>Debug Information</h4>
          <pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>
            {JSON.stringify(debugInfo, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default DebugInfo;
